import React, { useState } from 'react';

function domainFromWebsite(website) {
  if (!website) return null;
  try {
    return new URL(website).hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
}

export default function StockLogo({ symbol, website, size = 48 }) {
  const domain = domainFromWebsite(website);
  const [failed, setFailed] = useState(!domain);

  if (failed || !domain) {
    return (
      <div
        className="stock-logo-fallback"
        style={{ width: size, height: size, fontSize: size * 0.36 }}
      >
        {(symbol || '?').slice(0, 4)}
      </div>
    );
  }

  return (
    <img
      src={`https://logo.clearbit.com/${domain}`}
      alt={`${symbol} logo`}
      className="stock-logo"
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  );
}
